export class FrontLineDocReturnRequest {
  doNo: string;
  docTypes: string[];
  doLockHeader: string | null;
  applyUser: string | null;
  applyReason: string | null;

  constructor() {
    this.doNo = "";
    this.docTypes = [];
    this.doLockHeader = "";
    this.applyUser = "";
    this.applyReason = "";
  }
}
